import { makeStyles } from "@material-ui/styles";
import { dashboardStyle } from "../Components/InvoiceDetails/style";
import React, { useState, useEffect, useRef } from "react";
import TaxDetail from "../Components/TaxDetails/TaxDetails";
import TaxDetailTextField from "../Components/TaxDetails/TaxDetailTextField";
import { Delete } from "@material-ui/icons";
import { Download } from "@material-ui/icons";
import {
  Grid,
  TextField,
  Autocomplete,
  Typography,
  Backdrop,
  CircularProgress,
  IconButton,
  FormControl,
  Button,
  Box,
  InputAdornment,
} from "@material-ui/core";
import AttachmentsCover from "../../../components/Attachments/AttachmentsCover";
import {
  clearState,
  getCommentsByInvoiceId,
  getInvoiceByInvoiceIdAndRoleId,
  getVendorByPO,
  updateIPInvoice,
  getAllInvoiceDetailByInvoiceId,
  vendorTaxDetailForCnic,
  changeInvoiceStatus,
  getRefrenceDataList,
  getImportPoData,
  uploadAdditioalDocumentFile,
  getBatchInvoiceDetails,
} from "../actions";
import { GetBatchInvoiceDetailsWithname } from "../ProcessInvoice/actions";
import TaxTable from "../NewInvoice/Tables/Tax_Table";
import InvoiceRadioButtons from "../Components/InvoiceDetails/InvoiceRadiobuttons";
import InvoiceTextField from "../Components/InvoiceDetails/InvoiceTextFields";
import InvoiceDetailTextFields from "../Components/InvoiceDetails/InvoiceDetailTextFields";
import InvoiceCheckboxes from "../Components/InvoiceDetails/InvoiceCheckboxes";
import Card from "../../../StyledComponents/Card/Card";
import CardHeader from "../../../StyledComponents/Card/CardHeader";
import CardText from "../../../StyledComponents/Card/CardText";
import CardBody from "../../../StyledComponents/Card/CardBody";
import getParameterByName from "../../../Functions/functions";
import { ArrowBack } from "@material-ui/icons";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import GL_Table from "../NewInvoice/Tables/GL_Table";
import UsersByRole from "../NewInvoice/Dropdowns/UsersByRole";
import downloadAttachments from "../../../Functions/downloadAttachments";
import { getUserRoles } from "../../Home/actions";
import Heading from "../../../StyledComponents/Heading/Heading";
import CommentHistory from "../NewInvoice/Tables/CommentHistory";
import ExpenseTable from "../NewInvoice/Tables/ExpenseTable";
import ConfirmationModal from "../../../components/ConfirmModal/ConfirmationModal";
import DepartmentCoordinatorRent from "./DepartmentCoordinatorRent";
import jwt from "jsonwebtoken";
import axios from "axios";
 const token = localStorage.getItem("user_token");
const useStyles = makeStyles(dashboardStyle);
const DepartmentDetail = () => {
  const navigate = useNavigate();
  const invoiceId = getParameterByName("invoiceId");
  const roleId = getParameterByName("roleId");
  const roleName = getParameterByName("roleName");
  const vendorCode = getParameterByName("vendorCode");
  const edit = getParameterByName("edit");
  const invoiceStatus = getParameterByName("status");

  const invoicePayload = {
    Invoice_id: invoiceId,
    Vendor_Code: vendorCode,
  };
  const role = {
    roleId: roleId,
    roleName: roleName,
  };

  const user = jwt.decode(token);
 const [loamUser, setLoamUser] = useState([]);
  const [loamLoading, setLoamLoading] = useState(false);
   const [CeoCostCenter, setCeoCostCenter] = useState(false);
   const [higherLoamApprover, sethigherLoamApprover] = useState(false);
   const [loamApprover, setLoamApprover] = useState(false);
  const [openInvalidWarningDate, setOpenInvalidWarningDate] = useState(false);
  const [attachmentURL, setAttachmentURL] = useState("");
  const [attachmentURLList, setAttachmentURLList] = useState([]);
  const [poBasedState, setPoBasedState] = useState("Non-PO");
  const [physicalOrEInvoice, setPhysicalOrEInvoice] = useState("Physical");
  const [rolesLoading, setRolesLoading] = useState(false);
  const [roles, setRoles] = useState([]);
  const [attachInvoiceLoading, setAttachInvoiceLoading] = useState(false);
  const [commentsList, setCommentsList] = useState([]);
  const [commentsLoading, setCommentsLoading] = useState(false);
  const [reviwerFlag, setReviwerFlag] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [statusForPayload, setStatusForPayload] = useState("");
  const [selectedRole, setSelectedRole] = useState(
    role ? { roleName: role?.roleName } : ""
  );
  const invoice_attachmentRef = useRef(null);
  const additionalAttachmentRef = useRef(null);
  const highest_amount = 0;
  const [formState, setFormState] = useState({
    delv_Note_No: "",
    courier_Company: "",
    courier_Tracking_No: "",
    created_On: new Date(),
    updated_By: "",
    invoice_Accounts_list: [],
    updated_On: new Date(),
    comments: "",
    po_Date: new Date().toString(),
    plant_Code: "",
    file_name: "",
    quantity: "",
    charge_Account: "",
    cost_Center: "",
    asset_No: "",
    dept_coordinator: "",
    loam_approver: "",
    buyer: "",
    prInitiator: "",
    taxTeam: "",
    paymentTerm: "",
    invoiceDocURL: "",
    isSubmittedByVendor: true,
    supervisorLevel: "",
    sodReviewer: "",
    dcReviewer: "",
    loamReviewer: "",
    supervisorReviewer: "",
    logisticsTeam: "",
    logisticsReviewer: "",
    reviewer1: "",
    reviewer2: "",
    pcdvSegment: "",
    pcdvLocation: "",
    invoiceLocation: "",
    employeeCode: "",
    vP_InvoiceId: 0,
    taxCard_List: [],
    isInitiator: false,
    isDeptCordinator: false,
    isHR: false,
    isPCDV: false, // EFDV initiator
    isVPPayment: false,
    isVFPayment: false,
    isSubmittedByVendor: false,
    isImport: false,
    isLogistics: false,
    submission_Date: new Date(),

    //RENT Fields 
    provinceDuty : [],
    FCA_Details: [],
    Agreement_Details : [],
    stamp_Duty_Calculations : [],
    
    // submission_Date: moment().format("YYYY-MM-DD"),
    pO_Based: true,
    isPSID: false,
    psid: "",
    urgent: false,
    skipTaxStep: false,

    cnic: "",

    ntn: "",
    salesTaxCode: "",
    salesTaxAmount: "",
    calculateTax: true,
    eInvoice: true,

    cheque_No: "",
    invoice_Date: moment().format("YYYY-MM-DD"),
    invoice_Id: 0,
    grn_No: "",
    pO_No: "",
    barcode_No: "",
    demandType: "",
    invoice_Type: "",
    invoice_No: "",
    invoiceCategory: "",
    invoice_Desc: "",
    invoice_Amount: 0,
    final_Invoice_Amount: "",
    dept_coordinator: "",
    irUser: "",
    ipUser: "",
    taxTeam: "",
    vendor_Code: "",
    vendor_Name: "",
    lineManager: "",
    directorHR: "",
    sharedServices: "",
    invoice_attachment: "",
    additionalDocIds: [], // paths
    comments: "",
    due_Date: new Date(),

    //   for import invoice (extra field)
    currency: "PKR",
    posting_Date: new Date(),
    document_Type: "",
    firstClearText: "",
    secondClearText: "",
    created_By: "",

    // vendor Detail
    vendor_Details: [],
    // =======import invoice some tables are below ==========
    additionalDocIds_array: [], // additional documents in array

    // for Payment detail ("invoice_Payment" for po normal isInititor invoice).
    // ("invoice_Payment_Details" for import invoice) (will chnage).
    invoice_Payment: {
      inv_Payment_Id: 0,
      invoice_Id: 0,
      postingKey: "",
      sglInd: "",
      tType: "",
      paymentTerms: "",
      paymentDays: "",
      paymentMethod: "",
      paymentMethSupp: "",
      individualPayee: false,
      account: "",
      amount: 0,
      taxAmount: 0,
      dueOn: "",
      taxCode: "",
      description: "",
      order: "",
      costCenter: "",
      wbsElement: "",
      profitCenter: "",
      createdBy: "",
      createdDate: new Date(),
    },

    // Tax Table data (invoice_TaxDetails for po normal isInititor invoice)
    // ("invoice_Tax_Details" for import invoice) (will chnage).
    invoice_TaxDetails: [
      {
        taxId: 0,
        invoice_Id: 0,
        taxType: "",
        taxCode: "",
        amount: "",
        comments: "",
        created_By: "",
        created_On: new Date(),
        updated_By: "",
        updated_On: new Date(),
        taxCardId: 0,
      },
    ],

    // G/L Account detail. (actually for po_normal isInitiator)
    // (will change it to "invoice_Accounts_Details" for import invoice before hit api)
    invoice_Accounts: [
      // {
      //   accountId: 0,
      //   invoice_Id: 0,
      //   glAccount: "",
      //   costCenter: "",
      //   accountType: "",
      //   amount: 0,
      //   costCenterOwner: "",
      //   stCode: "",
      //   order: "",
      //   profitCenter: "",
      //   wbsElement: "",
      //   created_By: "",
      //   created_On: new Date(),
      //   updated_By: "",
      //   updated_On: new Date(),
      //   fixedAsset: "",
      //   tType: "",
      //   description: "",
      //   expenseDate: "",
      //   horizonId: "",
      //   department: "",
      //   vendorCode: "",
      // },
    ],

    // PO Table Detail
    // "pO_Details" this keyword is used acctualy on backend, before hit the api it changes
    invoicePORef_List: [
      // we use this keyword due to reuse the PODetail table component.
      // {
      //   poItem: "", //  item #
      //   poNumber: "", // poNumber
      //   refDoc: "", // GRN No
      //   quantity: "", // GRN quantity
      //   val_Loccur: "", // GRN amount
      //   invoicE_QTY: "", //  consumed quantity
      //   invoicE_VAL: 0, // consumed Amount
      //   inpuT_QTY: "", //  invoice QTY
      //   inpuT_VAL: "", //  Invoice amount
      //   currency: "", // currency
      // },
    ],
    verified: false,
  });
  const classes = useStyles();
  const [Post, setPost] = useState(true);
  const [openWarningBox, setOpenWarningBox] = useState(false);
  const showAttachmentsHandler = (attachment_URL) => {
    setAttachmentURL(attachment_URL);
  };
  const [importPaymentDetail, setImportPaymentDetail] = useState({
    invoice_Payment_Details: [],
  });
  const showVendorAndPO_NumberForImport = () => {
    let show =
      selectedRole?.roleName === "Department Coordinator" ? true : false;
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Deposit"
    ) {
      show = false;
    }
     if(selectedRole?.roleName === "Department Coordinator" && (formState?.invoice_Type === "Rent" || formState?.invoice_Type === "DES")) {
        show = false
    }

    return show;
  };
  const [newFormState, setNewFormState] = useState({
    taxCard_List: [],
    isInitiator: false,
    isDeptCordinator: false,
    isHR: false,
    isPCDV: false, // EFDV initiator
    isVPPayment: false,
    invoice_Accounts_list: [],
    isVFPayment: false,
    isSubmittedByVendor: false,
    courier_Tracking_No: "",
    isImport: false,
    isLogistics: false,
    submission_Date: moment().format("YYYY-MM-DD"),
    pO_Based: true,
    isPSID: false,
    psid: "",
    urgent: false,
    skipTaxStep: false,
    isReturn: false,
    invoice_Id: 0,
    grn_No: "",
    pO_No: "",
    barcode_No: "",
    demandType: "",
    invoice_Type: "",
    invoice_No: "",
    invoiceCategory: "",
    invoice_Desc: "",
    invoice_Amount: "",
    final_Invoice_Amount: "",
    dept_coordinator: "",
    irUser: "",
    ipUser: "",
    taxTeam: "",
    vendor_Code: "",
    vendor_Name: "",
    invoice_Date: moment().format("YYYY-MM-DD"),
    lineManager: "",
    directorHR: "",
    sharedServices: "",
    invoice_attachment: "",
    additionalDocIds: "", // paths
    comments: "",
    //   for import invoice (extra field)
    currency: "",
    posting_Date: new Date(),
    document_Type: "",
    firstClearText: "",
    secondClearText: "",
    created_By: "",

    // vendor Detail
    vendor_Details: [],
    // =======import invoice some tables are below ==========

    additionalDocIds_array: [], // additional documents in array

    due_Date: "",

    cnic: "",
    ntn: "",
    salesTaxCode: "",
    salesTaxAmount: "",
    calculateTax: true,
    eInvoice: true,

    currency: "",

    // for Payment detail
    invoice_Payment: {
      inv_Payment_Id: 0,
      invoice_Id: 0,
      postingKey: "",
      sglInd: "",
      tType: "",
      paymentTerms: "",
      paymentDays: "",
      paymentMethod: "",
      paymentMethSupp: "",
      individualPayee: false,
      account: "",
      amount: 0,
      taxAmount: 0,
      dueOn: "",
      taxCode: "",
      description: "",
      order: "",
      costCenter: "",
      wbsElement: "",
      profitCenter: "",
      createdBy: "",
      createdDate: new Date(),
    },

    // Tax Table
    invoice_TaxDetails: [
      {
        taxId: 0,
        invoice_Id: 0,
        taxType: "",
        taxCode: "",
        amount: "",
        comments: "",
        created_By: "",
        created_On: new Date(),
        updated_By: "",
        updated_On: new Date(),
        taxCardId: 0,
      },
    ],

     provinceDuty : [],
    FCA_Details: [],
    Agreement_Details : [],
    stamp_Duty_Calculations : [],
    // G/L Account detail.
    invoice_Accounts: [
      // {
      //   accountId: 0,
      //   invoice_Id: 0,
      //   glAccount: "",
      //   costCenter: "",
      //   accountType: "", // D/C (debit/ credit)
      //   amount: 0,
      //   costCenterOwner: "",
      //   stCode: "",
      //   order: "",
      //   profitCenter: "",
      //   wbsElement: "",
      //   created_By: "",
      //   created_On: new Date(),
      //   updated_By: "",
      //   updated_On: new Date(),
      //   fixedAsset: "",
      //   tType: "",
      //   description: "",
      //   expenseDate: "",
      //   horizonId: "",
      //   department: "",
      //   vendorCode: "",
      // },
    ],
    // PO Table Detail
    // "pO_Details" this keyword is used acctualy on backend, before hit the api it changes
    invoicePORef_List: [
      // we use this keyword due to reuse the PODetail table component.
      // {
      //   poItem: "", //  item #
      //   poNumber: "", // poNumber
      //   refDoc: "", // GRN No
      //   quantity: "", // GRN quantity
      //   val_Loccur: "", // GRN amount
      //   invoicE_QTY: "", //  consumed quantity
      //   invoicE_VAL: 0, // consumed Amount
      //   inpuT_QTY: "", //  invoice QTY
      //   inpuT_VAL: "", //  Invoice amount
      //   currency: "", // currency
      // },
    ],

    verified: false,
  });

  const [multipleData, setMultipleData] = useState({
    sglInd: [],
    tType: [],
    glAccount: [],
    postingKey: [],
    paymentDetail: [],
    paymentMethod: [],
    paymentTerms: [],
    paymentMethSupp: [],
    poData: [],
    vendorTaxDetail: [],
    currency: [],
    invoice_Type: [],
  });
  const confirmHandler = (e) => {
    e.preventDefault();
    // setOpenWarningBox(true);
    if (newFormState?.isReturn) {
      setConfirmationModal(true);
    }
  };
  useEffect(() => {
    if (formState.invoice_Id) {
      if (formState.pO_Based) {
        setPoBasedState("PO");
      } else {
        setPoBasedState("Non-PO");
      }
    }
  }, [formState.invoice_Id]);
  useEffect(() => {
    let filterd_data = [];
    if (formState?.additionalDocIds?.length > 0) {
      filterd_data = formState.additionalDocIds.filter((e) => Number(e) !== 0);
    }
    setAttachmentURLList((pre) => [
      formState?.invoice_attachment,
      ...filterd_data,
    ]);
    if (formState?.invoice_attachment) {
      setAttachmentURL(formState?.invoice_attachment);
    } else {
      setAttachmentURL(formState?.additionalDocIds[0]);
    }
  }, [formState?.invoice_attachment, formState?.additionalDocIds]);

  useEffect(() => {
    if (newFormState?.additionalDocIds?.length > 0) {
      setAttachmentURLList((pre) => [
        ...pre,
        newFormState?.additionalDocIds[
        newFormState?.additionalDocIds.length - 1
        ],
      ]);
    }
  }, [newFormState?.additionalDocIds]);
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setNewFormState((newFormState) => ({
      ...newFormState,
      [name]: value,
    }));

    if (name === "pO_No") {
      getVendorByPO(value, "vendor_Code", setNewFormState);
      // if passing PONumber
      // getPODetails(value, "",setFormState)
      // form dummy data
      // getPODetails(setFormState)
    }
  };
  const showVendorCodeForImport = () => {
    let show =
      selectedRole?.roleName === "Department Coordinator" ? true : false;
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Spare Parts"
    ) {
      show = false;
    }
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Material"
    ) {
      show = false;
    }
    if(selectedRole?.roleName === "Department Coordinator" && (formState?.invoice_Type === "Rent" || formState?.invoice_Type === "DES")) {
show = false
    }
    
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Samples"
    ) {
      show = false;
    }
    return show;
  };

  const submitHandler = () => {
    if (newFormState?.isReturn) {
      changeInvoiceStatus(
        formState.invoice_Id,
        statusForPayload,
        setConfirmationModal,
        setAttachInvoiceLoading,
        setSuccessMessage,
        setErrorMessage,
        navigate,
        newFormState.comments,
        newFormState.aditional_Comments,
        setPost
      );
      setConfirmationModal(false);
    }
  };

  const roleHandler = (newValue) => {
    setFormState((formState) => ({
      ...formState,
      isInitiator: newValue.roleName === "I2P Initiator" ? true : false,
      isHR: newValue.roleName === "HR" ? true : false,
      isPCDV: newValue.roleName === "EFDV Initiator" ? true : false,
      isImport: newValue.roleName === "Import" ? true : false,
      isLogistics: newValue.roleName === "Logistic" ? true : false,
    }));

    setSelectedRole(newValue);
  };
  const [dataLoading, setDataLoading] = useState(false);

    const getRefrenceDataCostCenter = async (refKey) => {
      const data = {
        refKey,
      };
      await axios({
        method: "get", //you can set what request you want to be
        url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetRefrenceDatList_v1`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          "Content-Type": "application/json",
        },
        params: data,
      })
        .then(async (res) => {
          setCeoCostCenter(res.data);
        })
        .catch((err) => {});
    };
    useEffect(() => {
      getRefrenceDataCostCenter("CeoCostCenter");
    }, []);
  

  useEffect(() => {
    getRefrenceDataList(
      "invoiceType",
      "invoice_Type",
      () => { },
      setMultipleData
    );
    getUserRoles(setRoles, setRolesLoading);

    if (invoicePayload && role) {
      vendorTaxDetailForCnic(setFormState, invoicePayload?.Vendor_Code);
      GetBatchInvoiceDetailsWithname(
        () => {},
        setImportPaymentDetail,
        setMultipleData,
        invoicePayload,
        role,
        setFormState,
        setDataLoading,
        setPoBasedState
      );
      // getInvoiceByInvoiceIdAndRoleId(invoicePayload, role, setFormState);
      // getInvoiceByInvoiceIdAndRoleId(
      //   setIsLoading,
      //   invoicePayload,
      //   role,
      //   setFormState
      // );

      // if (!formState.isImport) {
      // getAllInvoiceDetailByInvoiceId(
      //   setFormState,
      //   setMultipleData,
      //   invoicePayload?.Invoice_id,
      //   () => {},
      //   () => {},
      //   "",
      //   () => {}
      // );
      // }
      getCommentsByInvoiceId(
        setCommentsList,
        setCommentsLoading,
        invoicePayload?.Invoice_id
      );
    }
  }, []);
  useEffect(() => {
    if (roleName === "Reviewer") {
      setReviwerFlag(true);
    }
  }, []);

  useEffect(() => {
    if (formState?.invoice_Accounts_list?.length > 0) {
      let temp = [];
      for (let i = 0; i < formState?.invoice_Accounts_list?.length; i++) {
        const item = formState?.invoice_Accounts_list[i];
        const obj = {
          accountId: 0,
          invoice_Id: Number(invoicePayload?.Invoice_id),
          expenseDate: item?.expenseDate?.slice(0, -9),

          glAccount: item?.GLAccount,
          GLAccount: item?.GLAccount,
          costCenter: item?.CostCenter,
          // costCenter: { CostCenterCode: item?.CostCenter || "" },
          costCenterOwner: item?.CostCenterOwner,
          accountType: item?.accountType,
          costCenterOwnerName: item?.CostCenterOwnerName,
          wbsElement: item?.WBSElement,
          horizonId: item?.HorizonId,
          vendorCode: item?.VendorCode,
          amount: Number(item?.Amount),
          profitCenter: Number(item?.ProfitCenter),
          department: item?.Department,
          description: item?.Description || "",
          tType: item?.TType || "",
          fixedAsset: item?.FixedAsset || "",
          customerAccountNo: item?.CustomerAccountNo || item?.customerAccountNo || "",
          fsDocNo: item?.FSDocNo || item?.fsDocNo || "",
          fsDocDate: item?.FSDocDate || item?.fsDocDate || "",
        };
        temp.push(obj);
      }
      setNewFormState((formState) => ({
        ...formState,
        invoice_Accounts_list: temp,
        Expense_Accounts_list: temp,
      }));
    }
  }, [formState]);
  const calculateTotalGLAmount = () => {
    const totalGLAmount = newFormState.invoice_Accounts_list?.reduce(
      (accumulator, currentValue) => {
        return accumulator + Number(Number(currentValue.amount)?.toFixed(2));
      },
      0
    );
    return totalGLAmount;
  };
  const totalGLAmount = calculateTotalGLAmount();

   const getLoamApprover = async () => {
      setLoamLoading(true);
      if (formState?.invoice_Type) {
        var invParam = [];
        formState?.invoice_Accounts_list.forEach(function (item, i) {
          console.log("kkkyaaaa")
          console.log(item, "itemeee")
          if (item.Amount) {
            console.log(item.Amount, "item.Amount")
            var _cc =
              item.CostCenter == undefined || item.CostCenter == ""
                ? ""
                : item.CostCenter;
            if (_cc != "")
              _cc =
                _cc.split("-").length > 0
                  ? item?.CostCenter?.split("-")[0].trim()
                  : "";
            var _inv = formState?.invoice_Accounts_list.filter((i) => i.cost_center == _cc);
            if (_inv.length > 0) {
              _inv[0].invoice_amount =
                parseFloat(_inv[0].invoice_amount) + parseFloat(item.Amount);
            } else {
              invParam.push({
                invoice_amount: item.Amount?.toString(),
                cost_center: _cc,
                invoice_type: formState?.invoice_Type || "",
                personal_number: user?.personal_number
                  ? user?.personal_number
                  : "",
              });
            }
          }
        });
        var _invParam = [];
        invParam.forEach(function (item, i) {
          if (parseFloat(item.invoice_amount) >= parseFloat(highest_amount)) {
            // app.highest_amount = item.invoice_amount;
            _invParam.push({
              invoice_amount: item.invoice_amount?.toString(),
              cost_center: item.cost_center.trim(),
              invoice_type: item.invoice_type,
              personal_number: user?.personal_number ? user?.personal_number : "",
            });
          }
        });
       
        await axios({
          method: "post", //you can set what request you want to be
          url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetApprovers`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
            "Content-Type": "application/json",
          },
          data: _invParam,
          // data: payload,
        })
          .then(async (res) => {
            if (res?.data[0]?.Error) {
              // Handle the case when the API response contains an error message
              console.error(res.data[0].Error);
  
              // setLoamUser(additionalUsers);
              setLoamUser([]);
            } else if (res?.data && res?.data?.length > 0) {
              if (
                CeoCostCenter.length > 0 &&
                CeoCostCenter[0].ReferenceText !== ""
              ) {
                let _b = false;
                CeoCostCenter[0].ReferenceText.split(",").forEach((reference) => {
                  if (!_b) {
                    _b =
                      newFormState?.invoice_Accounts_list?.filter(
                        (i) => i.costCenter == reference
                      ).length > 0;
                  }
                });
  
                if (
                  !_b &&
                  res?.data.filter((i) => i?.CareerLadder === "HGRL 24").length >
                    0
                ) {
                  res?.data.splice(res?.data?.length - 1, 1);
                }
                // Set the filtered data to loamApprovers state
              }
              // const combinedUsers = [...res.data, ...additionalUsers];
              const combinedUsers = res.data; // for production build
              // Combine the API response data with the additional list of users
              const uniqueUsersMap = {};
  
              //  filter out duplicates
              combinedUsers.forEach((user) => {
                const key = `${user?.CareerLadder}-${user?.Name}`;
                uniqueUsersMap[key] = user;
              });
  
              // Extract unique users from the map and convert them back to an array
              const uniqueUsers = Object.values(uniqueUsersMap);
  
              setLoamUser(uniqueUsers);
            }
  
            setLoamLoading(false);
          })
          .catch((err) => {
            setLoamLoading(false);
          });
      }
    };

      useEffect(() => {
       
          getLoamApprover();
        
      }, [
        formState?.invoice_Accounts_list,
        formState?.invoice_Type,
        formState?.pcdvSegment,
      ]);
    const LoamUserHandler = (newValue) => {
    const hasLowerCareerLadder = loamUser?.some((user) => {
      const selectedCareerLadder = parseInt(
        (newValue?.CareerLadder || newValue?.CarrierLadder)?.replace(/\D/g, ""),
        10
      );
      const userCareerLadder = parseInt(
        (user?.CareerLadder || user?.CarrierLadder)?.replace(/\D/g, ""),
        10
      );
      return userCareerLadder < selectedCareerLadder;
    });
    if (hasLowerCareerLadder) {
      sethigherLoamApprover(true);
    }
    if (!newValue) {
      setNewFormState({
        ...newFormState,
        loam_approver: "",
      });
    } else {
      setNewFormState({
        ...newFormState,
        loam_approver: newValue?.UserID ? newValue?.UserID : newValue?.Name,
      });
    }

    if (newValue?.UserID === "" || newValue?.UserID === "null") {
      setLoamApprover(true);
    } else {
      setLoamApprover(false);
      setErrorMessage("");
    }
  };

  return (
    <Card>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={dataLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <CardHeader color="primary" text>
        <CardText
          style={{
            padding: "0px 27px",
            backgroundColor: "#031C30",
            color: "white",
          }}
        >
          <Grid container justifyContent="space-between">
            <Grid item xs={2} sm={3} md={3} lg={6}>
              <h1 style={{ fontSize: "24px" }}>DRL Approval</h1>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <IconButton
                variant="contained"
                style={{ float: "right", marginTop: "1.5%" }}
                onClick={() => navigate("/home")}
              >
                <ArrowBack style={{ color: "#fff" }} titleAccess="Go Back" />
              </IconButton>
            </Grid>
          </Grid>
        </CardText>
      </CardHeader>
      <CardBody>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={attachInvoiceLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        <Grid container style={{ padding: "0px 5px" }}>
          <Grid item xs={12} sm={12} md={12} lg={6}>
            <Grid container style={{ marginTop: "1px", padding: "0px 5px" }}>
              {/* Submitter role */}
              <Grid item xs={12} sm={12} md={6} lg={6} style={{ marginTop: "8px" }}>
                <Typography style={{ color: "black" }}>Submitter Role:</Typography>
                <Autocomplete
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "30px",
                      textAlign: "center",
                      display: "flex",
                      alignItems: "center",
                    },
                    "& .MuiInputBase-input": {
                      marginTop: "-4px", // Adjust this value to move the text up
                      fontSize: 15
                    },
                  }}
                  id="submitter_role"
                  options={roles}
                  size="small"
                  value={selectedRole}
                  getOptionLabel={(option) =>
                    (option !== "" && `${option?.roleName}`) || ""
                  }
                  loading={rolesLoading}
                  onChange={(event, newValue) => {
                    roleHandler(newValue);
                  }}
                  disabled
                  renderInput={(params) => (
                    <TextField {...params} type="text" name="" required />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={9} lg={9}></Grid>
            </Grid>
            {!formState.isDeptCordinator && (
              <InvoiceCheckboxes
                formState={formState}
                setFormState={setFormState}
                selectedRole="Department Coordinator"
                disabled={true}
              />
            )}
            {!formState.isDeptCordinator && (
              <InvoiceRadioButtons
                formState={formState}
                setFormState={setFormState}
                selectedRole="Department Coordinator"
                physicalOrEInvoice={physicalOrEInvoice}
                poBasedState={poBasedState}
                alignForAttachment={true}
              />
            )}
            {/*<InvoiceTextField
              newFormState={formState}
              setNewFormState={setFormState}
              selectedRole="Department Coordinator"
              disabled={true}
              poBasedState={poBasedState}
              showVendorAndPO_NumberForImport={showVendorAndPO_NumberForImport}
              showVendorCodeForImport={showVendorCodeForImport}
              invoice_attachmentRef={invoice_attachmentRef}
              additionalAttachmentRef={additionalAttachmentRef}
              setAttachInvoiceLoading={setAttachInvoiceLoading}
              //   setAttchmentFile_UI={setAttchmentFile_UI}
              //   attachmentFile_UI={attachmentFile_UI}
              physicalOrEInvoice={physicalOrEInvoice}
              changeHandler={changeHandler}
              alignForAttachment={true}
              setAttachmentURLList={setAttachmentURLList}
              attachmentURLList={attachmentURLList}
              setAttachmentURL={setAttachmentURL}
              showAttachmentsHandler={showAttachmentsHandler}
              setOpenInvalidWarningDate={setOpenInvalidWarningDate}
              multipleData={multipleData}
            />*/}
            <InvoiceDetailTextFields
              newFormState={formState}
              setNewFormState={setFormState}
              selectedRole="Department Coordinator"
              disabled={true}
              poBasedState={poBasedState}
              showVendorAndPO_NumberForImport={showVendorAndPO_NumberForImport}
              showVendorCodeForImport={showVendorCodeForImport}
              invoice_attachmentRef={invoice_attachmentRef}
              additionalAttachmentRef={additionalAttachmentRef}
              setAttachInvoiceLoading={setAttachInvoiceLoading}
              //   setAttchmentFile_UI={setAttchmentFile_UI}
              //   attachmentFile_UI={attachmentFile_UI}
              physicalOrEInvoice={physicalOrEInvoice}
              changeHandler={changeHandler}
              alignForAttachment={true}
              setAttachmentURLList={setAttachmentURLList}
              attachmentURLList={attachmentURLList}
              setAttachmentURL={setAttachmentURL}
              showAttachmentsHandler={showAttachmentsHandler}
              setOpenInvalidWarningDate={setOpenInvalidWarningDate}
              multipleData={multipleData}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={6}
            style={{ paddingLeft: "7px" }}
          >
            <Heading title="Attachment Preview">
              <span>
                {attachmentURL != ""
                  ? attachmentURL == formState?.invoice_attachment
                    ? " (Invoice Attachmnets)"
                    : "(Additional Documents)"
                  : null}
              </span>
            </Heading>

            <AttachmentsCover
              attachmentURLList={attachmentURLList}
              setAttachmentURLList={setAttachmentURLList}
              attachmentURL={attachmentURL}
              setAttachmentURL={setAttachmentURL}
            />
          </Grid>
        </Grid>
        <form onSubmit={confirmHandler} style={{ marginTop: "50px" }}>
          {!formState.skipTaxStep && (
            <>
              <Heading title="Tax" />
              {/* <TaxDetail
                formState={newFormState}
                setFormState={setNewFormState}
                invoice_Amount={newFormState.invoice_Amount}
                edit={edit}
              />*/}
              <TaxDetailTextField
                formState={formState}
                setFormState={setFormState}
                invoice_Amount={formState.invoice_Amount}
                edit={"false"}
              />
              {formState?.taxCard_List.length > 0 && (
                <TaxTable
                  formState={formState}
                  setFormState={setFormState}
                  invoice_Amount={formState.invoice_Amount}
                  invoicePayload={invoicePayload}
                  show={true}
                />
              )}
            </>
          )}
          <span></span>
          <>
            {formState?.isPCDV && (
              <Grid container style={{ marginTop: "5px" }}>
                <Grid item xs={12} sm={12} md={6} lg={12}>
                  <ExpenseTable
                    formState={newFormState}
                    setFormState={setNewFormState}
                    editable={false}
                  />
                </Grid>
              </Grid>
            )}
            {!formState?.isPCDV && formState?.invoice_Accounts?.length > 0 && (
              <Grid container style={{ marginTop: "14px" }}>
                <Heading title="G/L Account" />
                <GL_Table
                  // formState={formState}
                  formState={newFormState}
                  setFormState={setNewFormState}
                  show={true}
                  reviwerFlag={true}
                />
              </Grid>
            )}

              {
                formState?.invoice_Type === "Rent" && formState?.isDeptCordinator && (

                  <Grid container item xs={12} sm={12} md={3} lg={3} style={{ marginTop: "14px" }}>
                                      <Typography style={{ color: "black" }}>
                                       
                                        Loam Approver:
                                      </Typography>
                                      <Autocomplete
                                        sx={{
                                          "& .MuiInputBase-root": {
                                            height: "30px",
                                            textAlign: "center",
                                            display: "flex",
                                            alignItems: "center",
                                          },
                                          "& .MuiInputBase-input": {
                                            marginTop: "-4px", // Adjust this value to move the text up
                                            fontSize: 15,
                                          },
                                        }}
                                        size="small"
                                        style={{ width: "100%" }}
                                        disabled={true}
                                        value={
                                          loamUser.find((user) =>
                                            user?.UserID
                                              ? user?.UserID === formState?.loam_approver
                                              : user?.Name === formState?.loam_approver
                                          ) || ""
                                        }
                                        onChange={(e, newValue) => {
                                          LoamUserHandler(newValue);
                                        }}
                                        options={loamUser}
                                        getOptionLabel={(option) =>
                                          option
                                            ? option?.PersonalNumber
                                              ? `${option?.PersonalNumber} -` +
                                                `${option?.Name}`
                                              : `${option?.Name}`
                                            : ""
                                        }
                                        loading={loamLoading}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            // variant="standard"
                                            size="small"
                                            // required
                                            // InputProps={{
                                            //   ...params.InputProps,
                                            //   disableUnderline: true,
                                            // }}
                                            placeholder="Select loam Approver"
                                            required={
                                              newFormState?.isProceed &&
                                              !newFormState?.isReturn
                                            }
                                          />
                                        )}
                                      />
                                    </Grid>
                )
              }
            

               {
              formState?.isDeptCordinator && formState?.invoice_Type === 'Rent' && (
                <DepartmentCoordinatorRent 
                  formState={formState}
                  setFormState={setFormState}
                  show={false}
                  reviwerFlag={true}
                  role={
                    (selectedRole?.roleName === "Department Coordinator" && formState.invoice_Type === 'Rent')
                      ? ""
                      : "HR"
                  }
                />
              )
            }
            
          {totalGLAmount!==0 &&  <Grid container spacing={0} mt={1}>
                    <Grid item xs={12} sm={4} md={4} lg={2}>
                      <Typography
                        style={{
                          color: "#fff",
                          borderRadius: "2px",
                          padding: "10px",

                          // backgroundColor: "#4caf50",
                          backgroundColor: "#4caf50",
                        }}
                      >
                      {`${formState.invoice_Type==='Final Settlement - Distributor' ? 'Customer Account Total' : 'Total GL Amount'} : ${totalGLAmount?.toLocaleString()}`}
                      </Typography>
                    </Grid>
                  </Grid>}
          </>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <CommentHistory
              commentsList={commentsList}
              commentsLoading={commentsLoading}
            />
          </Grid>
          <Grid
            container
            spacing={1}
            style={{ margin: "10px 0px", padding: "0px 5px" }}
          >
            {/*<Grid
              item
              xs={12}
              sm={12}
              md={3}
              lg={3}
            >
              <FormControl fullWidth size="small">
                <UsersByRole
                  label="Loam Approver"
                  apiString="Loam Approver"
                  name="loam_approver"
                  formState={newFormState}
                  changeHandler={changeHandler}
                  required={true}
                  disabled={reviwerFlag}
                  classes={classes}
                />
              </FormControl>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={3}
              lg={3}
            ><FormControl fullWidth size="small">
                <UsersByRole
                  label="Add Reviewer"
                  apiString="Add Reviewer"
                  name="reviewer"
                  formState={newFormState}
                  changeHandler={changeHandler}
                  required={true}
                  disabled={false}
                  classes={classes}
                />
              </FormControl>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={3}
              lg={3}
            >

              <Button
                color="secondary"
                variant="contained"
                sx={{ mt: 3 }}

              >
                Add Another Reviewer
              </Button>

            </Grid>*/}
          </Grid>
          {/* <Grid container spacing={2} style={{ marginBottom: "20px" , padding:"0px 5px" }}>
            <Grid item xs={12} sm={12} md={12} lg={3}>
              <Typography>
                Additional Documnets: <span className={classes.asterisk}>*</span>
              </Typography>
              <TextField
                fullWidth
                size="small"
                sx={{
                  // width: "70%",
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                id="outlined-basic"
                variant="outlined"
                // onChange={() => }
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <input
                        ref={additionalAttachmentRef}
                        type="file"
                        name="additionalDocIds"
                        required={newFormState?.isReject === false ? true : false}
                        onChange={(e) =>
                          uploadAdditioalDocumentFile(
                            e,
                            setNewFormState,
                            setAttachInvoiceLoading,
                            "additionalDocIds",
                            additionalAttachmentRef
                          )
                        }
                        style={{ width: "209px" }}
                      />
                    </InputAdornment>
                  ),
                }}
              />
              {newFormState?.additionalDocIds?.length > 0 &&
                newFormState?.additionalDocIds?.map((f, index) => {
                  const s = f.split("\\");
                  const ss = s[s.length - 1];
                  return (
                    <>
                      {f !== "" ? (
                        <>

                          <Delete
                            color="danger"
                            fontSize="small"
                            onClick={() => {
                              const files = newFormState?.additionalDocIds?.filter(
                                (x, i) => {
                                  const n = x.split("\\");
                                  const nn = n[n.length - 1];
                                  return nn !== ss;
                                }
                              );
                              setNewFormState((formState) => ({
                                ...formState,
                                additionalDocIds: files,
                              }));

                              //removing data from attachemt list for preview
                              let filtered_attachs =
                                attachmentURLList?.filter((x) => x !== f);
                              setAttachmentURLList(filtered_attachs);
                              setAttachmentURL(
                                filtered_attachs[filtered_attachs.length - 1]
                              );
                            }}
                          />


                          <Download
                            onClick={() => {
                              downloadAttachments(f);
                            }}
                          />
                          <IconButton
                            size="small"
                            onClick={() => {
                              const allowedExtensions = [".png",".pdf",".jpg",".jpeg",".PNG",".JPG",".JPEG",".PNG",".PDF"];
                              const fileExtension = "." + ss.split(".").pop();
                              if (allowedExtensions.includes(fileExtension)) {
                                setAttachmentURL(f);
                              } else {
                                setAttachmentURL(f);

                                window.open(`${process.env.REACT_APP_API_URL}/${f.path}`, '_blank');
                              }
                            
                            }}
                          >
                            <span style={{ fontSize: "10px" }}>{ss}</span>
                          </IconButton>
                          <div></div>
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  );
                })}
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={3} lg={12}>
            <Typography style={{color:"black"}}>
              Additional Details:
              <span className={classes.asterisk}>*</span>
            </Typography>
            <TextField
              fullWidth
              multiline
              rows={2}
              maxRows={4}
              // size="small"
              sx={{
                // width: "70%",
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              id="outlined-basic"
              variant="outlined"
              name="comments"
              required
              value={formState.comments}
              onChange={(e) => {
                setFormState({ ...formState, comments: e.target.value });
              }}
            />
          </Grid>
        */}
          {(invoiceStatus === "SendToReviewer" ||
            invoiceStatus === "SendToLoamApprover") && roleName === "Department Coordinator" && (
              <Grid item xs={12} sm={12} md={6} lg={6}>
                {Post && (
                  <>
                    <Typography style={{ color: "black" }}>
                      Comments:
                      {/* <span className={classes.asterisk}>*</span> */}
                    </Typography>
                    <TextField
                      fullWidth
                      multiline
                      name="comments"
                      value={newFormState?.comments}
                      onChange={changeHandler}
                      maxRows={4}
                      // size="small"
                      sx={{
                        // width: "70%",
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                      }}
                      id="outlined-basic"
                      variant="outlined"
                      required={newFormState?.isReturn}
                    />
                    <Button
                      style={{
                        margin: "2px",
                        marginTop: "6px",
                        color: "white",
                        fontWeight: "700",
                      }}
                      variant="contained"
                      color="secondary"
                      type="submit"
                      // id="saveAsDraft"
                      onClick={() => {
                        setNewFormState((formState) => ({
                          ...formState,
                          isReturn: true,
                          isProceed: false,
                        }));
                        setConfirmationMessage(
                          "Are you sure to Recall  this invoice "
                        );
                        setStatusForPayload("SendToDeptCoordinator");
                        //  setConfirmationModal(true);
                      }}
                    >
                      Recall
                    </Button>
                  </>
                )}

              </Grid>
            )}
          <Grid container style={{ margin: "20px 0px" }}>
            <Grid item xs={12} sm={12} md={3} lg={12}>
              {/* <Typography style={{color:"black"}}>
                Comments
                <span className={classes.asterisk}>*</span>
              </Typography>
              <TextField
                fullWidth
                multiline
                rows={2}
                maxRows={4}
                // size="small"
                sx={{
                  // width: "70%",
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                id="outlined-basic"
                variant="outlined"
                name="comments"
                required={formState?.isReject}
                value={formState.comments}
                onChange={(e) => {
                  setFormState({ ...formState, comments: e.target.value });
                }}
              />
              */}

              {!reviwerFlag ? (
                <Box display="flex" justifyContent={"flex-end"} mt={2}>
                  <Button
                    color="error"
                    variant="contained"
                    type="submit"
                    style={{ display: `${edit === "true" ? "" : "none"}` }}
                  // onClick={() => setFormState({ ...formState, isReject: true })}
                  >
                    Cancel
                  </Button>
                  <Button
                    color="secondary"
                    variant="contained"
                    type="submit"
                    sx={{ ml: 2 }}
                    style={{ display: `${edit === "true" ? "" : "none"}` }}
                    onClick={() =>
                      setFormState({ ...formState, isReject: false })
                    }
                  >
                    Return to Invoice Receiver
                  </Button>
                  <Button
                    color="secondary"
                    variant="contained"
                    type="submit"
                    style={{ display: `${edit === "true" ? "" : "none"}` }}
                    sx={{ ml: 2 }}
                    onClick={() =>
                      setFormState({ ...formState, isReject: false })
                    }
                  >
                    Initiate Loam Approval
                  </Button>
                </Box>
              ) : (
                <Box display="flex" justifyContent={"flex-end"} mt={2}>
                  <Button
                    color="error"
                    variant="contained"
                    type="submit"
                    style={{ display: `${edit === "true" ? "" : "none"}` }}
                    onClick={() =>
                      setFormState({ ...formState, isReject: true })
                    }
                  >
                    Reject
                  </Button>
                  <Button
                    color="secondary"
                    variant="contained"
                    type="submit"
                    sx={{ ml: 2 }}
                    style={{ display: `${edit === "true" ? "" : "none"}` }}
                    onClick={() =>
                      setFormState({ ...formState, isReject: false })
                    }
                  >
                    Approve
                  </Button>
                </Box>
              )}
            </Grid>
          </Grid>
        </form>
        {confirmationModal && (
          <ConfirmationModal
            open={confirmationModal}
            close={() => setConfirmationModal(false)}
            message={confirmationMessage}
            submit={submitHandler}
            loading={attachInvoiceLoading}
          />
        )}
      </CardBody>
    </Card>
  );
};

export default DepartmentDetail;